<template>
  <div id="app">
    <Header />
    <Skills />
    <WorkExperience />
    <Portfolio />
    <About />
    <Contact />
    <Footer />
  </div>
</template>

<script>
import Header from "./Vue/pages/Header.vue";
import About from "./Vue/pages/About.vue";
import Skills from "./Vue/pages/Skills.vue";
import Portfolio from "./Vue/pages/Portfolio.vue";
import Contact from "./Vue/pages/Contact.vue";
import Footer from "./Vue/pages/Footer.vue";
import WorkExperience from "./Vue/pages/WorkExperience.vue";

export default {
  name: "App",
  components: {
    Header,
    Skills,
    WorkExperience,
    About,
    Portfolio,
    Contact,
    Footer,
  },
};
</script>

<style>
@import "./styles/css/main.css";
</style>
